// ============================================================================
// EmployeeLogin — Selezione nome dipendente (accesso diretto)
// ============================================================================

import { HardHat, ArrowLeft } from "lucide-react";
import { AVATAR_COLORS } from "../../lib/constants";

export default function EmployeeLogin({ onBack, onLogin, dipendenti = [] }) {
  return (
    <div style={{
      minHeight: "100vh",
      background: `
        radial-gradient(ellipse at 30% 0%, rgba(192,57,43,0.10) 0%, transparent 50%),
        radial-gradient(ellipse at 70% 100%, rgba(192,57,43,0.06) 0%, transparent 50%),
        var(--bg)
      `,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: 24,
      position: "relative",
      overflow: "hidden",
    }}>
      {/* Pattern sfondo */}
      <div style={{ position: "absolute", inset: 0, pointerEvents: "none", opacity: 0.02, backgroundImage: "repeating-linear-gradient(45deg, transparent, transparent 60px, rgba(255,255,255,0.5) 60px, rgba(255,255,255,0.5) 61px)" }} />

      <div className="animate-scale-in" style={{
        width: "100%",
        maxWidth: 420,
        background: "rgba(255,255,255,0.02)",
        borderRadius: 28,
        border: "1px solid rgba(255,255,255,0.06)",
        padding: "32px 28px",
        boxShadow: "0 24px 80px rgba(0,0,0,0.4)",
        backdropFilter: "blur(20px)",
      }}>
        {/* Back */}
        <button onClick={onBack} style={{
          background: "none", border: "none", color: "var(--text-dim)",
          cursor: "pointer", fontSize: 14, padding: 0, marginBottom: 24,
          display: "flex", alignItems: "center", gap: 6, fontFamily: "var(--font)", fontWeight: 500,
          transition: "color 0.2s",
        }}
        onMouseEnter={(e) => e.currentTarget.style.color = "var(--text)"}
        onMouseLeave={(e) => e.currentTarget.style.color = "var(--text-dim)"}
        >
          <ArrowLeft size={18} /> Indietro
        </button>

        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{
            width: 64, height: 64, borderRadius: 18,
            background: "linear-gradient(135deg, rgba(192,57,43,0.15), rgba(192,57,43,0.05))",
            border: "1px solid rgba(192,57,43,0.25)",
            display: "flex", alignItems: "center", justifyContent: "center",
            margin: "0 auto 16px",
            color: "#C0392B",
            boxShadow: "0 12px 36px rgba(192,57,43,0.15)",
          }}>
            <HardHat size={28} strokeWidth={1.6} />
          </div>
          <h2 style={{ color: "var(--text)", fontSize: 24, fontWeight: 700, letterSpacing: "-0.3px" }}>Area Dipendenti</h2>
          <p style={{ color: "var(--text-dim)", fontSize: 13, marginTop: 6 }}>Seleziona il tuo nome</p>
        </div>

        {/* Lista dipendenti */}
        <div style={{ maxHeight: 380, overflowY: "auto", display: "flex", flexDirection: "column", gap: 6 }}>
          {dipendenti.map((d) => (
            <button
              key={d.id}
              onClick={() => onLogin(d)}
              style={{
                display: "flex", alignItems: "center", gap: 12,
                padding: "14px 16px",
                background: "rgba(255,255,255,0.02)",
                border: "1px solid rgba(255,255,255,0.06)",
                borderRadius: 14,
                color: "var(--text)", cursor: "pointer",
                transition: "all 0.25s cubic-bezier(0.16, 1, 0.3, 1)",
                fontSize: 15, fontWeight: 500, textAlign: "left",
                width: "100%", fontFamily: "var(--font)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(192,57,43,0.08)";
                e.currentTarget.style.borderColor = "rgba(192,57,43,0.25)";
                e.currentTarget.style.transform = "translateX(6px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "rgba(255,255,255,0.02)";
                e.currentTarget.style.borderColor = "rgba(255,255,255,0.06)";
                e.currentTarget.style.transform = "translateX(0)";
              }}
            >
              <div style={{
                width: 42, height: 42, borderRadius: 12, flexShrink: 0,
                background: `linear-gradient(135deg, ${AVATAR_COLORS[(d.id - 1) % AVATAR_COLORS.length][0]}, ${AVATAR_COLORS[(d.id - 1) % AVATAR_COLORS.length][1]})`,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontWeight: 700, fontSize: 13, color: "#fff",
                boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
              }}>
                {d.avatar}
              </div>
              {d.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
